import { getPublicFrontendOrigin } from '@/lib/getPublicAppUrl'

/**
 * Cognito Hosted UI / managed-login logout URL.
 *
 * App cookie clears (POST /auth/logout) do not remove the Cognito domain
 * session cookie. Hitting `/logout` on the Cognito domain clears it and then
 * redirects to `logoutUri`, which must exactly match an Allowed sign-out URL
 * on the app client. Defaults to the public frontend origin (no path), which
 * is what the Cognito app client registers.
 */
export function getCognitoHostedUiLogoutUrl(
    logoutUri: string = getPublicFrontendOrigin(),
): string | null {
    const clientId = process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID || ''
    const cognitoDomain = process.env.NEXT_PUBLIC_COGNITO_DOMAIN || ''
    if (!clientId || !cognitoDomain) {
        return null
    }

    const params = new URLSearchParams({
        client_id: clientId,
        logout_uri: logoutUri,
    })
    return `https://${cognitoDomain}/logout?${params.toString()}`
}
